import { CloseIcon } from "components/ui/icons/uploadbar/CloseIcon"
import { FurnitureStatusIcon } from "components/ui/customWebviewer/ElevationReferencesSidebar/icons/FurnitureStatusIcon"
import { BackButton } from "components/ui/customWebviewer/shared/BackButton/BackButton"
import type { TFurnitureStatus } from "types/elevationReferences.type"
import style from "./FurnitureHeader.module.scss"

const { header, headerLeft, headerIcon, headerTitle, closeButton } = style

type Props = {
	title: string
	status?: TFurnitureStatus
	onClose?: () => void
	onBack?: () => void
}

export const FurnitureHeader = ({ title, status, onClose, onBack }: Props) => {
	return (
		<div className={header} data-hotkey-skip>
			<div className={headerLeft}>
				{onBack && <BackButton onClick={onBack} ariaLabel="Jump to connected elevation reference" />}
				<span className={headerIcon}>
					<FurnitureStatusIcon status={status} />
				</span>
				<span className={headerTitle}>{title}</span>
			</div>
			<button className={closeButton} onClick={onClose} aria-label="Close sidebar">
				<CloseIcon />
			</button>
		</div>
	)
}
